import cartMixedStocksComputeRequest from '../../_flux/components/product/cart_mixed_stocks_compute_request';
import {
    closeOrderFormLayerAction,
    closeOrderStatusLayerAction,
    closePostcodeLayerAction,
    closeProductLayerAction,
    openPostcodeLayerAction,
    openProductLayerAction,
    setErrorMessageAction,
    unsetErrorMessageAction,
    setFittingOptionsAction,
    setShippingOptionsAction,
    setCartAction,
    setSelectedFittingOption,
    withFittingOptionAction,
    addFittingService, clearFittingService,
} from '../../_flux/actions/product_mixed_stocks_lightbox_actions';
import ProductMixedStocksLightboxStore from '../../_flux/stores/product_mixed_stocks_lightbox_store';
import fittingOptionsComputeRequest from '../../_flux/components/product/product_mixed_stocks_fitting_options_request';
import shippingOptionsComputeRequest from '../../_flux/components/product/product_mixed_stocks_shipping_options_compute_request';
import { hideAction as unlockUi, showAction as lockUi } from '../../_flux/actions/ui_lock_actions';
import FitterService from '../../_flux/stores/models/fitter_service';
export default function onCartMixedStocksComputeRequest(postcode, sku, quantity) {
    unsetErrorMessageAction();
    lockUi();
    cartMixedStocksComputeRequest(postcode, sku, quantity)
        .then((result) => {
            setCartAction(result);
            const { cart } = ProductMixedStocksLightboxStore.getState();
            fittingOptionsComputeRequest(cart)
                .then((result) => {
                    clearFittingService();
                    withFittingOptionAction();
                    setFittingOptionsAction(result);
                    const { fittingOptions } = ProductMixedStocksLightboxStore.getState();
                    let selectedFsId = null;
                    let fittingServices = [];
                    fittingOptions.map((fittingOption) => {
                        if (null === selectedFsId) {
                            selectedFsId = fittingOption.fs.fsId;
                            fittingServices = fittingOption.services;
                        }

                        if (fittingOption.fs.isMobile) {
                            selectedFsId = fittingOption.fs.fsId;
                            fittingServices = fittingOption.services;
                        }
                    });
                    setSelectedFittingOption(selectedFsId);
                    fittingServices.map((fittingService) => {
                        if (fittingService instanceof FitterService) {
                            addFittingService(fittingService.type);
                        }
                    });

                    const { cart } = ProductMixedStocksLightboxStore.getState();
                    shippingOptionsComputeRequest(cart)
                        .then((result) => {
                            unlockUi();
                            setShippingOptionsAction(result);
                        })
                        .catch(() => {
                            unlockUi();
                            setErrorMessageAction('product-mixed-stocks-shipping-option-compute-failed');
                        });
                    closePostcodeLayerAction();
                    closeOrderStatusLayerAction();
                    closeOrderFormLayerAction();
                    openProductLayerAction();
                })
                .catch(() => {
                    unlockUi();
                    setErrorMessageAction('product-mixed-stocks-fitting-option-compute-failed');
                });
        })
        .catch(() => {
            setErrorMessageAction('product-mixed-stocks-product-batch-loading-failed');
            openPostcodeLayerAction();
            closeProductLayerAction();
            closeOrderStatusLayerAction();
            closeOrderFormLayerAction();
            unlockUi();
        });
}
